"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoleEnum = void 0;
var UserRoleEnum;
(function (UserRoleEnum) {
    UserRoleEnum["User"] = "user";
    UserRoleEnum["Admin"] = "admin";
})(UserRoleEnum = exports.UserRoleEnum || (exports.UserRoleEnum = {}));
//# sourceMappingURL=user-role-enum.js.map